import React, { useEffect, useState, useContext } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import {
  createQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import {
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Form,
  Input,
  Toggle,
  Select,
  Button,
  Alert,
  Spinner,
} from "design-react-kit";
import { listOfRoles } from "../../services/helpers";

const UsersModal = ({
  modalOpen,
  modalCloseHandler,
  handleTypologyChange,
  selectedUserClients,
  selectedUserRoles,
  handleRolesChange,
  selectedUser,
  setUsers,
  setResults,
  notifyUser,
}) => {
  const [typologyOptions, setTypologyOptions] = useState(null);
  const [selectedTypology, setSelectedTypology] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState(null);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    if (modalOpen) {
      setIsLoading(true);
      setError(null);
      if (
        userContext.selectedClientName !== null &&
        userContext.selectedClientFiscalCode !== null
      ) {
        sendApiRequest(
          "Client/GetAllClientCodes",
          "GET",
          true,
          { fiscalCode: userContext.selectedClientFiscalCode, flowId: null },
          signIn,
          signOut,
          navigate,
          createQueryString,
          userContext
        ).then((response) => {
          if (response !== undefined) {
            if (response.errors !== null) {
              setError(response.errors);
              setIsLoading(false);
            } else {
              let clientCodes = [];
              response.data.map((item) =>
                clientCodes.push({
                  value: item.code,
                  label: item.name,
                })
              );
              setTypologyOptions(clientCodes);
              setIsLoading(false);
            }
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  useEffect(() => {
    if (modalOpen) {
      setTimeout(() => {
        if (document.getElementById("userEmail") !== null) {
          setEmail(document.getElementById("userEmail").value);
          setSelectedTypology(selectedUserClients);
          setSelectedRoles(selectedUserRoles);
        }
      }, 300);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen, selectedUserClients, selectedUserRoles]);

  useEffect(() => {
    if (modalOpen && selectedUser !== null) {
      setIsActive(selectedUser.isActive);
    }
  }, [selectedUser, modalOpen]);

  useEffect(() => {
    if (modalOpen) {
      const emailRegex = new RegExp(
        /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/gm
      );
      setTimeout(() => {
        if (selectedUser !== null) {
          if (
            selectedTypology !== null &&
            selectedTypology !== undefined &&
            selectedTypology.length > 0 &&
            selectedRoles !== null &&
            selectedRoles !== undefined &&
            selectedRoles.length > 0 &&
            email !== null &&
            email !== "" &&
            emailRegex.test(email) &&
            (selectedTypology.length !== selectedUser.codes.length ||
              selectedRoles.length !== selectedUser.roles.length ||
              email !== selectedUser.email ||
              isActive !== selectedUser.isActive ||
              !checkEqual(selectedTypology, selectedUser.codes) ||
              !checkEqual(selectedRoles, selectedUser.roles))
          ) {
            document.getElementById("user-save").disabled = false;
          } else {
            document.getElementById("user-save").disabled = true;
          }
        } else {
          if (
            selectedTypology !== null &&
            selectedTypology !== undefined &&
            selectedTypology.length > 0 &&
            email !== null &&
            email !== "" &&
            emailRegex.test(email)
          ) {
            document.getElementById("user-save").disabled = false;
          } else {
            document.getElementById("user-save").disabled = true;
          }
        }
      }, 400);
    }
  }, [
    selectedTypology,
    email,
    modalOpen,
    isActive,
    selectedUser,
    selectedRoles,
  ]);

  const checkEqual = (selectedServices, userServices) => {
    let matches = 0;
    if (selectedServices !== null && userServices !== null) {
      const valuesFromSelectedServices = selectedServices.values();
      let selectedCodes = [];
      let userCodes = [];

      for (const item of valuesFromSelectedServices) {
        selectedCodes.push(item.value);
      }

      userServices.map((item) => userCodes.push(item.code));

      for (let index = 0; index < selectedCodes.length; index++) {
        const element1 = selectedCodes[index];
        for (let index = 0; index < userCodes.length; index++) {
          const element2 = userCodes[index];
          if (element1 === element2) matches++;
        }
      }

      if (matches === userCodes.length) {
        return true;
      } else {
        return false;
      }
    }
  };

  const handleTypologyChangeHandler = (selectedOption) => {
    handleClientsChange(selectedOption);
    handleTypologyChange(selectedOption);
  };

  const handleRolesChangeHandler = (selectedOption) => {
    setSelectedRoles(selectedOption);
    handleRolesChange(selectedOption);
  };

  const handleClientsChange = (selectedOption) =>
    setSelectedTypology(selectedOption);

  const upsertUserHandler = (e) => {
    e.preventDefault();
    const isDisabled = document.getElementById("user-save").disabled;
    if (
      !isDisabled &&
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      setError(null);
      setIsLoading(true);
      const id = document.getElementById("userEmail").getAttribute("user-id");
      let clientCodes = null;
      if (selectedTypology !== null) {
        clientCodes = selectedTypology.map((item) => item.value);
      }
      let roles = null;
      if (selectedRoles !== null) {
        roles = selectedRoles.map((item) => item.value);
      }

      sendApiRequest(
        "User/UpsertUser",
        "POST",
        true,
        {
          id: id !== null ? id : "",
          email: email,
          isActive: document.querySelector(".toggles .form-check-input")
            .checked,
          fiscalCode: userContext.selectedClientFiscalCode,
          codes: clientCodes,
          roles: roles,
        },
        signIn,
        signOut,
        navigate,
        null,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setTimeout(() => {
              sendApiRequest(
                "User/GetAllUsers",
                "GET",
                true,
                {
                  fiscalCode: userContext.selectedClientFiscalCode,
                  flowId: null,
                },
                signIn,
                signOut,
                navigate,
                createQueryString,
                userContext
              ).then((response) => {
                if (response !== undefined) {
                  if (response.errors !== null) {
                    setError(response.errors);
                    setIsLoading(false);
                  } else {
                    setUsers(response.data.users);
                    setResults(response.data.users);
                    setIsLoading(false);
                    notifyUser(
                      id !== null
                        ? "Aggiornamento account utente completato con successo!"
                        : "Creazione account utente completata con successo!",
                      "success",
                      "it-check"
                    );
                    modalCloseHandler();
                  }
                }
              });
            }, 500);
          }
        }
      });
    }
  };

  return (
    <Modal
      isOpen={modalOpen}
      toggle={modalCloseHandler}
      align="center"
      scrollable
      labelledBy="users"
    >
      <ModalHeader toggle={modalCloseHandler} id="users" className="mb-4">
        Crea nuovo utente (ENTE)
      </ModalHeader>
      <ModalBody>
        {error !== null && error.length !== undefined && (
          <Alert color="danger">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            className="file-info-spinner"
            style={{
              height: "10px",
              position: "relative",
              marginBottom: "2rem",
              marginRight: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        <Form className="mr-auto ml-auto">
          <div className="form-row">
            <FormGroup className="col-sm-12 m-0">
              <Input
                id="userEmail"
                type="email"
                label="Email"
                placeholder="Inserisci l'email"
                style={{ width: "95%" }}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormGroup>
          </div>
          <div className="form-row">
            <FormGroup className="col-sm-12 m-0 mb-5 position-relative">
              <div className="bootstrap-select-wrapper col-12  ml-0">
                <label htmlFor="userRoles">Ruoli</label>
                <Select
                  id="userRoles"
                  isMulti={true}
                  onChange={handleRolesChangeHandler}
                  options={listOfRoles}
                  value={selectedUserRoles}
                  placeholder="-Seleziona i ruoli assegnati all'utente-"
                  aria-label="Seleziona"
                />
              </div>
            </FormGroup>
          </div>
          <div className="form-row">
            <FormGroup className="col-sm-12 m-0 mb-5 position-relative">
              <div className="bootstrap-select-wrapper col-12  ml-0">
                <label htmlFor="userClients">Tipologia</label>
                <Select
                  id="userClients"
                  isMulti={true}
                  onChange={handleTypologyChangeHandler}
                  options={typologyOptions}
                  value={selectedUserClients}
                  placeholder="-Seleziona le tipologie di servizio accessibili dall'utente-"
                  aria-label="Seleziona"
                />
              </div>
            </FormGroup>
          </div>
          <FormGroup
            check
            className="form-check-group d-flex align-items-center justify-content-start save"
          >
            <Toggle
              id="isActive"
              className="isActive"
              onChange={(e) => setIsActive(e.target.checked)}
            />
            <span className="mb-2 toggles-span">Attiva utente </span>
          </FormGroup>
          <FormGroup className="col-sm-12 mb-2 d-flex align-items-center justify-content-end">
            <Button
              id="user-cancel"
              color="white"
              className="mr-2"
              onClick={modalCloseHandler}
            >
              Annulla
            </Button>
            <Button
              style={{
                backgroundColor: "#5EB423",
                color: "#fff",
                padding: "7px 15px",
              }}
              id="user-save"
              type="submit"
              onClick={(e) => upsertUserHandler(e)}
            >
              <Icon icon="it-check" fill="#ffffff" /> Salva
            </Button>
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default UsersModal;
